<template>
  <div class="archive20231003" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} {{ info.title }}</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">{{ info.subtitle }}</div>
              <a href="https://sites.google.com/view/paclic38" target="_blank">PACLIC 38 (2024)</a>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20241209_1.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20241209_2.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>